<template>
  <div class="group">
    <div class="grouptop">
      <!-- <div class="groupname">{{$t('group.Groups_list')}}</div> -->
      <div class="creat">
        <button class="button-solid button button-create" @click="creatgroup">
          <i class="el-icon-circle-plus-outline el-icon--left"></i>
          {{$t('group.Create_groups')}}
        </button>
      </div>
    </div>
    <div class="sections">
      <!-- <div class="title">{{$t('group.Groups_list')}}</div> -->
      <div class="table">
        <el-table
          :data="grouplist"
          stripe
          border
          height="100%"
          :row-style="{height:0}"
          :cell-style="{padding:0}"
          :header-cell-style="{background:'#F2F5F7',color:'#606266'}"
          v-loading="grouploading"
          element-loading-spinner="el-icon-loading"
        >
        <!-- :empty-text="$t('message.nodata')" -->
          <el-table-column type="selection"></el-table-column>
          <el-table-column
            prop="name"
            :show-overflow-tooltip="true"
            :label="$t('group.Group_name')"
          ></el-table-column>
          <el-table-column
            prop="memberCount"
            :show-overflow-tooltip="true"
            :label="$t('group.userCount')"
          ></el-table-column>
          <el-table-column :show-overflow-tooltip="true" :label="$t('group.note')">
            <template slot-scope="scope">
              <span 
              :title="scope.row.desc||'--'"
              >{{scope.row.desc||'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" :label="this.$t('group.Operate')">
            <template slot-scope="scope">
              <el-button
                type="text"
                class="operation"
                :title="$t('account.Edit')"
                @click="editcount(scope.row)"
              >
                <i class="iconfont icon-edit1"></i>
              </el-button>
              <el-button
                type="text"
                class="operation"
                :title="$t('group.Delete')"
                @click="detelegroup(scope.row)"
              >
                <i class="iconfont icon-delete"></i>
              </el-button>
            </template>
          </el-table-column>
          <div v-show="emptyText" slot="empty"><img src="@/assets/img/empty_text.png"/>
            <div style="line-height: 32px">{{$t('account.nodata')}}</div>
            <p><el-button size="small" type="primary" @click="creatgroup">{{$t('group.Create_groups')}}</el-button></p>
          </div>
        </el-table>
      </div>
    </div>
    <!--编辑分组 -->
    <group-dialog
      :title="$t('group.Edit_groups')"
      :visible.sync="showEditDialog"
      :width="'450px'"
      v-if="showEditDialog"
    >
      <el-form
        ref="editGroupsForm"
        :model="groupsDatas"
        label-position="right"
        slot="content"
        :rules="Rules"
        class="chuangjian grid"
      >
        <el-form-item :label="$t('group.Group_name1')" prop="groupName">
          <el-input type="text" v-model.trim="groupsDatas.groupName" autocomplete="off">
            <!-- <img slot="prefix" src="@/assets/img/usr.png" style="width:18px;height:22px;" /> -->
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('group.note1')" prop="desc">
          <el-input type="text" v-model.trim="groupsDatas.desc" autocomplete="off">
            <!-- <img slot="prefix" src="@/assets/img/fenzu.png" style="width:18px;height:22px;" /> -->
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <!-- <button class="button-hollow" @click="showEditDialog = false">{{$t('group.cancel')}}</button> -->
        <button class="button-solid" @click="editGroups">{{$t('group.confirm')}}</button>
      </div>
    </group-dialog>
    <!-- 新增分组 -->
    <group-dialog
      :title="$t('group.Create_groups')"
      :visible.sync="showCreatgroupDialog"
      :width="'450px'"
      v-if="showCreatgroupDialog"
    >
      <el-form
        ref="form"
        :model="group"
        label-position="right"
        slot="content"
        :rules="Rules"
        class="chuangjian grid"
      >
        <el-form-item :label="$t('group.Group_name1')" prop="groupName">
          <el-input type="text" v-model.trim="group.groupName" autocomplete="off">
            <!-- <img slot="prefix" src="@/assets/img/usr.png" style="width:18px;height:22px;" /> -->
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('group.note1')" prop="desc">
          <el-input type="text" v-model.trim="group.desc" autocomplete="off">
            <!-- <img slot="prefix" src="@/assets/img/fenzu.png" style="width:18px;height:22px;" /> -->
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <!-- <button class="button-hollow" @click="closeDialog">{{$t('account.cancel')}}</button> -->
        <button class="button-solid" @click="creatnewgroup">{{$t('account.submit')}}</button>
      </div>
    </group-dialog>
    <!-- 删除分组 去掉弹框的heard不加title=""和footer noFooter -->
    <group-dialog
      :visible.sync="showDeleteDialog"
      :width="'450px'"
      v-if="showDeleteDialog"
      noFooter
    >
      <div class="content_tishi" slot="content">
        <div class="tital">
        <i class="iconfont icon-gantanhao"></i>
        <span class="contentdelete">{{$t('group.deleteConfirm')}}</span>
        </div>
        <div class="disabledescr">{{$t('account.notRecovered')}}</div>
        <div class="deletfotter">
          <button class="button-solid" @click="deleteoldgroup">{{$t('group.confirm')}}</button>
          <button class="button-hollow" @click="closeDialog">{{$t('group.cancel')}}</button>
        </div>
      </div>
    </group-dialog>
  </div>
</template>
<script>
import groupDialog from "@/components/dialog";
export default {
  components: {
    groupDialog
  },
  data() {
    return {
      emptyText: false,
      grouploading: false,
      grouplist: [],
      showCreatgroupDialog: false,
      showDeleteDialog: false,
      showEditDialog: false,
      loadingeditcount: false,
      group: {
        groupName: "",
        desc: ""
      },
      groupsDatas: {
        groupName: "",
        desc: "",
        id: ""
      },
      Rules: {
        groupName: [
          {
            required: true,
            message: this.$t("group.entername"),
            trigger: "blur"
          }
        ]
      },
      params: ""
    };
  },
  created() {
    this.getData();
  },
  methods: {
    //编辑分组
    editGroups() {
      this.$refs.editGroupsForm.validate(valid => {
        if (!valid) return false;
        this.$request
          .get("editAccountGroup", {
            id: this.groupsDatas.id,
            desc: this.groupsDatas.desc,
            name: this.groupsDatas.groupName
          })
          .then(res => {
            if (res.err == 0) {
              this.$message.success(this.$t("group.editsuc"));
              this.showEditDialog = false;
            } else {
              this.$message.error(this.$t(`errCode.${res.err}`));
            }
            setTimeout(() => {
              this.getData();
            }, 500);
          });
      });
    },
    //打开编辑分组对话框
    editcount(info) {
      this.showEditDialog = true;
      this.groupsDatas.groupName = info.name;
      this.groupsDatas.desc = info.desc;
      this.groupsDatas.id = info.id;
    },
    //关闭新增分组按钮
    closeDialog() {
      this.showCreatgroupDialog = false;
      this.showDeleteDialog = false;
    },
    //删除分组按钮
    detelegroup(info) {
      this.showDeleteDialog = true;
      this.params = info;
    },
    //删除分组
    deleteoldgroup() {
      this.$request.get("delAccountGroup", { id: this.params.id }).then(res => {
        if (res.err == 0) {
          this.$message.success(this.$t("group.deletesuc"));
          this.showDeleteDialog = false;
          this.getData();
        } else {
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
      });
    },
    //点击创建分组按钮
    creatgroup() {
      this.group.groupName = null;
      this.group.desc = null;
      this.showCreatgroupDialog = true;
    },
    //创建分组
    creatnewgroup() {
      this.$refs.form.validate(valid => {
        if (!valid) return false;
        this.$request
          .get("addAccountGroup", {
            groupName: this.group.groupName,
            desc: this.group.desc
          })
          .then(res => {
            if (res.err == 0) {
              this.$message.success(this.$t("group.creatsuc"));
              this.showCreatgroupDialog = false;
            } else {
              this.$message.error(this.$t(`errCode.${res.err}`));
            }
            setTimeout(() => {
              this.getData();
            }, 500);
          });
      });
    },

    //获取分组数据
    getData() {
      this.grouploading = true;
      this.$request.get("queryAccountGroup").then(res => {
        if (res.err == 0) {
          this.grouplist = res.dat.group;
          // this.pagination = res.dat;
        }else{
          this.emptyText = true;
        }
        this.grouploading = false;
      });
    }
  }
};
</script>
<style lang="less" scoped>
.group {
  .chuangjian {
    // /deep/ .el-input__prefix {
    //   width: 40px;
    //   display: flex;
    //   align-items: center;
    //   justify-content: center;
    // }
    // /deep/ .el-input__inner {
    //   padding-left: 40px;
    // }
  }
  background-color: #fff;
  margin: 10px;
  // margin: 24px 24px 50px 24px;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
   .grouptop {
    // display: flex;
    // flex-direction: row;
    // justify-content: space-between;
    padding: 20px 24px;
    // padding: 15px 24px 5px;
    // .groupname {
    //    font-size:16px;
    //    font-weight: bold;
    //    color: #333;
    //    letter-spacing: 1.5px;
    // }
    // border-bottom: 1px solid #f2f2f2;
  }
  .creat {
    float: right;
    // margin-bottom: 15px;
    .button-solid {
      float: right;
      display: flex;
      align-items: center;
      line-height: 32px;
      padding: 0 16px;
      float: right;
      .el-icon--left {
        margin-right: 8px;
        font-size: 20px;
      }
    }
  }
  .tableButton{
    margin-top:20px;
  }
  .sections {
    margin: 0 24px 10px;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow:hidden;
    .table {
      flex: 1;
      // overflow: hidden;
      overflow: auto;
      /deep/ .el-icon-loading{
            font-size: 28px;
        }
    }
  }
  .contentdelete {
    font-size: 20px;
    font-weight: 600;
  }
  // .deletfotter {
  //   margin-top: 50px;
  //   .button-hollow {
  //     width: 100px;
  //     height: 40px;
  //     margin-right: 40px;
  //   }
  //   .button-solid {
  //     width: 100px;
  //     height: 40px;
  //   }
  // }
}
</style>
<style>
/* .el-table--border:after,
.el-table--group:after,
.el-table:before {
    background-color: #C0C4CC;
}

.el-table--border,
.el-table--group {
    border-color: #C0C4CC;
}

.el-table td,
.el-table th.is-leaf {
        border-bottom: 1px solid #C0C4CC;
}

.el-table--border th,
.el-table--border th.gutter:last-of-type {
        border-bottom: 1px solid #C0C4CC;
}

.el-table--border td,
.el-table--border th {
        border-right: 1px solid #C0C4CC;
} */
</style>
